import { NgModule } from '@angular/core';

import {ProjectsComponent} from "./projects.component";
import {ProjectsRoutingModule} from "./projects-routing.module";
import {ListComponent} from "./list/list.component";
import {DetailsComponent} from "./details/details.component";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {StatusComponent} from "./shared/status/status.component";
import {PartsComponent} from "./shared/project-parts/parts.component";
import {DetailsTabComponent} from "./shared/details-tab/details-tab.component";
import {CredentialsComponent} from "./shared/credentials/credentials.component";
import {OutsourcingComponent} from "./shared/outsourcing/outsourcing.component";
import {ThirdPartyComponent} from "./shared/3rd-party/third-party.component";
import {ChangelogComponent} from "./shared/changelog/changelog.component";
import {IsLateComponent} from "./shared/is-late/is-late.component";
import {GoToUrlComponent} from "./shared/go-to-url/go-to-url.component";
import {FrameworkComponent} from "./shared/framework/framework.component";
import {SampleInputComponent} from "./forms/sample-input/sample-input.component";
import {DialogsModule} from "../dialogs/dialogs.module";
import {CopyComponent} from './shared/copy/copy.component';
import {SortComponent} from './shared/sort/sort.component';

@NgModule({
    declarations: [
        ProjectsComponent,
        ListComponent,
        DetailsComponent,
        StatusComponent,
        PartsComponent,
        DetailsTabComponent,
        CredentialsComponent,
        OutsourcingComponent,
        ThirdPartyComponent,
        ChangelogComponent,
        IsLateComponent,
        GoToUrlComponent,
        FrameworkComponent,
        SampleInputComponent,
        CopyComponent,
        SortComponent
    ],
    imports: [
        ProjectsRoutingModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DialogsModule
    ],
    bootstrap: [ProjectsComponent]
})
export class ProjectsModule { }



// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/projects.module.ts